export default __webpack_public_path__ + "static/golden-circle-f97d352647a1287f9fd5176282e1799c.svg";